export const INITIALIZE_LOCALIZE = 'localize/initialize';
export const SET_TRANSLATIONS_FOR_LANG = 'localize/setTranslationsForLang';
export const SET_ACTIVE_LOCALE = 'localize/setActiveLocale';
